import { logger } from "cayo.ui";
import { fromSavedQuery } from "@cayo/shared/components/GridContainer/gridModel/savedQuery.portal";
import { IActionHandlerParams } from "../types";

const log = logger.getLogger("action-handlers");

export function editQuery(_: string, parameters?: IActionHandlerParams) {
  if (!parameters || !parameters.dispatch || parameters.objects?.length !== 1) {
    return;
  }

  log.debug("editQuery -> parameters", parameters);
  const refreshCallback = () => {
    parameters.dispatch!({ kind: "refresh", hideLoading: true, keepSelection: true });
  };
  return parameters.dispatch({
    kind: "escalate",
    action: { kind: "openEditForm", query: fromSavedQuery(parameters.objects[0]), refreshCallback },
  });
}
